<lib-dialog-layout>
    <ng-container title>
        {{ data.Title }}
    </ng-container>
    <ng-container content>
        <p [ngClass]="{'text-center': isMobile}" [innerHTML]="data.Text! | trustHtml"></p>
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogDanger">
            <lib-button
            [role]="ButtonRole.Primary"
                id="LibraryDialogPrimaryButton"
                class="text-nowrap"
                [kind]="ButtonKind.Danger"
                [loading]="primaryActionClicked"
                qaTag="delete-dialog-primary-action-button"
                (clicked)="PrimaryAction()">
                <ng-container label>
                    {{ primaryButtonText }}
                </ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Secondary"
                id="LibraryDialogSecondaryButton"
                [kind]="ButtonKind.NeutralSecondary"
                [disabled]="primaryActionClicked"
                qaTag="delete-dialog-dismiss-action-button"
                (clicked)="DismissAction()">
                <ng-container label>
                    {{ secondaryButtonText }}
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
